import { allowedByDefault, featuresKeys } from '@/app/constants/featuresKeys';
import { IResources, IUser, Usuario } from '@/app/models/user';

class UserMapper {
  /**
   * Converts a persistence Usuario object to a domain IUser object.
   * @param usuario - The Usuario object to convert.
   * @returns The converted IUser object.
   */
  public static toDomain(usuario: Usuario): IUser {
    return {
      name: usuario.nome,
      email: usuario.email,
      username: usuario.usuario,
      productions:
        usuario.producoes?.map((prod) => ({
          name: prod.nome,
          code: prod.codigo,
          resources: (
            (usuario.permissoes
              ?.map((perm) => ({
                path: featuresKeys[perm.nome as keyof typeof featuresKeys] ?? '',
                permissions: perm.funcionalidades || [],
              }))
              .filter((perm) => perm.path) || []) as IResources[]
          ).concat(allowedByDefault),
        })) || [],
    };
  }
}

export { UserMapper };
